import React from "react";
import { Box, H1 } from "orcs-design-system";
import PropTypes from "prop-types";

const Heading = ({ title = "Tenant Settings" }) => {
  return (
    <Box
      bg="white"
      boxBorder="default"
      borderRadius={2}
      borderBottomLeftRadius={0}
      borderBottomRightRadius={0}
      p="r"
    >
      <H1>{title}</H1>
    </Box>
  );
};

Heading.propTypes = {
  title: PropTypes.string,
};

export default Heading;
